import React from "react"
import { NavLink, Link } from "react-router-dom"
import { FaTimes, FaChartBar, FaNewspaper, FaTrophy, FaFilePdf, FaFileInvoiceDollar, FaArrowLeft, FaLink, FaCalendarAlt, FaWallet, FaUserTie, FaHandshake, FaTv, FaHorseHead, FaTicketAlt } from "react-icons/fa"

export default function SidebarCircuito({ circuito, isOpen, onClose, basePath, siteBaseUrl }) {
  const logoUrl = circuito?.imagem
    ? `https://api.ticketdovaqueiro.com/uploads/${circuito.imagem}`
    : null

  // 💡 LINKS DINÂMICOS
  const navLinks = [
    { to: `${basePath}`, label: "Dashboard", icon: <FaChartBar />, end: true },
    { to: `${basePath}/financeiro`, label: "Financeiro", icon: <FaWallet /> },
    { to: `${basePath}/associados`, label: "Associados", icon: <FaUserTie /> },
    { to: `${basePath}/cavalos`, label: "Cavalos", icon: <FaHorseHead /> },
    { to: `${basePath}/despesas`, label: "Despesas", icon: <FaFileInvoiceDollar /> },
    { to: `${basePath}/cupons`, label: "Cupons", icon: <FaTicketAlt /> },
    { to: `${basePath}/noticias`, label: "Notícias", icon: <FaNewspaper /> },
    { to: `${basePath}/patrocinadores`, label: "Patrocinadores", icon: <FaHandshake /> },
    { to: `${basePath}/ranking`, label: "Editar Ranking", icon: <FaTrophy /> },
    { to: `${basePath}/campeoes`, label: "Campeões", icon: <FaTrophy /> },
    { to: `${basePath}/etapas`, label: "Etapas", icon: <FaCalendarAlt /> },
    { to: `${basePath}/afiliados`, label: "Afiliados", icon: <FaLink /> },
    { to: `${basePath}/regulamento`, label: "Regulamento", icon: <FaFilePdf /> },
    { to: `${basePath}/transmissao`, label: "Transmissão TV", icon: <FaTv /> },
  ]

  return (
    <aside className={`pc-sidebar ${isOpen ? "pc-sidebar--open" : ""}`}>
      <div className="pc-sidebar__header">
        <div className="pc-sidebar__brand">
          {logoUrl && (
            <img src={logoUrl} alt={circuito?.nome} className="pc-sidebar__logo" />
          )}
          <div className="pc-sidebar__info">
            <div className="pc-sidebar__name">{circuito?.nome}</div>
            <div className="pc-sidebar__subtitle">Painel de Controle</div>
          </div>
        </div>
        <button className="pc-mobile-toggle" onClick={onClose} style={{ display: isOpen ? "flex" : "none" }}><FaTimes /></button>
      </div>

      <nav className="pc-sidebar__nav">
        {navLinks.map((link) => (
          <NavLink
            key={link.label}
            to={link.to}
            end={link.end}
            onClick={onClose}
            className={({ isActive }) => `pc-sidebar__link ${isActive ? "pc-sidebar__link--active" : ""}`}
          >
            <span className="pc-sidebar__link-icon">{link.icon}</span>
            <span>{link.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="pc-sidebar__footer">
        {/* 💡 Botão Voltar Dinâmico */}
        <Link to={`${siteBaseUrl}/`} className="pc-sidebar__back">
          <FaArrowLeft />
          <span>Voltar ao site</span>
        </Link>
      </div>
    </aside>
  )
}